import Script from "next/script"
import { useRegionCode } from "modules/i18n/hooks/useRegionCode"
import { RegionCode } from "modules/i18n/config/region"

/**
 * Echobox web tag for TC-UK. Loads after page is interactive to ensure
 * canonical tags are present in the DOM before the script runs.
 */
export const Echobox = () => {
  const regionCode = useRegionCode()

  if (regionCode !== RegionCode.Uk) {
    return null
  }

  return <Script async id="ebx" src="//applets.ebxcdn.com/ebx.js" strategy="afterInteractive" />
}
